export default "__VITE_ASSET__CPMMQ4JS__"